import React, { ReactNode, useEffect, useMemo, useRef, useState } from "react"
import "./App.css"
import { useSwipeable } from "react-swipeable"
import { FilePanel } from "./PhotoUpload/FilePanel"
import { FlexH, FlexV, LineH, LineV, StImage } from "./ui/ui"
import { Photo } from "./graphql/schema"
import { apiPrefix } from "./api/api"
import { getPhotos } from "./api/photo"
import { PhotoEl } from "./PhotoEl/PhotoEl"
import ImageStream, { PhotoListEl } from "./ImageStreamEl/ImageStreamEl"
import { AboutEl } from "./AboutEl/AboutEl"
import { useIsPortrait } from "./hooks/useIsPortrait"
import { getAssetsPath } from "./sharedTypes/responseData"

function App() {
  const [menu, setMenu] = useState<string[]>(["主页", "关于"])
  const [selectedMenu, setSelectedMenu] = useState<string>("主页")
  const menuItemsRef = useRef<Record<string, HTMLElement | null>>({})
  const indicatorRef = useRef<HTMLDivElement>(null)

  const isPortrait = useIsPortrait()

  useEffect(() => {
    if (localStorage.getItem("auth") && !menu.includes("管理")) {
      setMenu([...menu, "管理"])
    }
  }, [menu])

  useEffect(() => {
    const selectedElement = menuItemsRef.current[selectedMenu]
    var indicatorEl = indicatorRef.current
    if (selectedElement && indicatorEl) {
      if (isPortrait) {
        indicatorEl.style.left = `${selectedElement.offsetLeft}px`
        indicatorEl.style.top = "0"
      } else {
        indicatorEl.style.top = `${selectedElement.offsetTop}px`
        indicatorEl.style.left = "0"
      }
    }
  }, [isPortrait, selectedMenu])

  const [mainPagePhoto, setMainPagePhoto] = useState<Photo>()
  const mainPagePhotoUrl = useMemo(() => {
    if (!mainPagePhoto) return
    return `${apiPrefix}/${getAssetsPath(mainPagePhoto.fileId || "")}`
  }, [mainPagePhoto])

  useEffect(() => {
    ;(async () => {
      const photos = await getPhotos({ limit: 100, offset: 0 })
      const photoIdx = Math.floor(Math.random() * photos.length)
      const photo = photos[photoIdx]
      setMainPagePhoto(photo)
    })()
  }, [])

  const contentMap = useMemo(() => {
    const map: Record<string, ReactNode> = {
      主页: (
        <PhotoEl
          url={mainPagePhotoUrl}
          title={mainPagePhoto?.title || ""}
          description={mainPagePhoto?.description || ""}
          size={isPortrait ? "60vw" : "min(36rem, 80vw)"}
          maxSize={isPortrait ? "60vw" : "min(36rem, 80vw)"}
        />
      ),
      关于: <AboutEl></AboutEl>,
    }
    if (localStorage.getItem("auth")) {
      map["管理"] = <FilePanel></FilePanel>
    }
    return map
  }, [
    isPortrait,
    mainPagePhoto?.description,
    mainPagePhoto?.title,
    mainPagePhotoUrl,
  ])

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (!isPortrait) return
      const menuKeys = Object.keys(contentMap)
      const selectedKeyIdx = menuKeys.indexOf(selectedMenu)
      if (selectedKeyIdx < menuKeys.length - 1)
        setSelectedMenu(menuKeys[selectedKeyIdx + 1])
    },
    onSwipedRight: () => {
      if (!isPortrait) return
      const menuKeys = Object.keys(contentMap)
      const selectedKeyIdx = menuKeys.indexOf(selectedMenu)
      if (selectedKeyIdx > 0) setSelectedMenu(menuKeys[selectedKeyIdx - 1])
    },
    trackMouse: true,
  })

  return (
    <div
      className="App"
      style={{
        backgroundColor: "var(--bg-color)",
      }}
    >
      <div
        style={{
          padding: "min(4rem, 5vw)",
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
          boxSizing: "border-box",
        }}
      >
        <FlexV
          style={{
            width: "max-content",
          }}
        >
          <div
            style={{
              fontSize: "4rem",
              marginBottom: "2rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src="Inswhis.png"
              alt="logo"
              style={{
                display: "block",
                width: "4rem",
                height: "4rem",
                marginRight: "1rem",
                position: "relative",
                top: "0.2rem",
              }}
            ></img>
            Inswhis
          </div>
          <FlexH
            style={{
              justifyContent: "space-between",
              width: "100%",
              height: "100%",
              flexDirection: isPortrait ? "column" : "row",
            }}
          >
            <FlexH
              style={{
                alignItems: "flex-start",
                gap: "0",
                alignSelf: "stretch",
                marginRight: isPortrait ? "auto" : "10rem",
                marginBottom: isPortrait ? "20vw" : "auto",
                flexShrink: "0",
                flexDirection: isPortrait ? "column" : "row",
                width: isPortrait ? "100%" : "auto",
                height: isPortrait ? "auto" : "100%",
              }}
            >
              <div
                ref={indicatorRef}
                style={{
                  width: "1rem",
                  height: "1rem",
                  backgroundColor: "black",
                  position: "relative",
                }}
              ></div>
              {isPortrait ? (
                <LineH
                  style={{
                    width: "100%",
                  }}
                ></LineH>
              ) : (
                <LineV
                  style={{
                    height: "100%",
                  }}
                ></LineV>
              )}
              <FlexV
                style={{
                  marginLeft: isPortrait ? "unset" : "1rem",
                  marginTop: isPortrait ? "1rem" : "unset",
                  position: "relative",
                  gap: "1rem",
                  flexDirection: isPortrait ? "row" : "column",
                }}
              >
                {menu.map((text) => (
                  <div
                    className="hoverable"
                    key={text}
                    ref={(el) => {
                      menuItemsRef.current[text] = el
                    }}
                    style={{
                      fontSize: "2rem",
                    }}
                    onClick={() => {
                      setSelectedMenu(text)
                    }}
                  >
                    {text}
                  </div>
                ))}
              </FlexV>
            </FlexH>
            <div
              {...swipeHandlers}
              style={{
                maxWidth: "60rem",
                width: "80vw",
                height: "100%",
              }}
            >
              {contentMap[selectedMenu] || null}
            </div>
          </FlexH>
        </FlexV>
      </div>
      {selectedMenu === "主页" ? (
        <FlexH
          style={{
            marginTop: "10rem",
            justifyContent: "center",
            overflow: "unset",
          }}
        >
          <PhotoListEl columns={isPortrait ? 1 : 2}></PhotoListEl>
        </FlexH>
      ) : null}
    </div>
  )
}

export default App
